var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24PxStrategicPlanning01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-strategic-planning-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,11A4.5,4.5,0,1,0,2,6.5,4.51,4.51,0,0,0,6.5,11Zm0-7A2.5,2.5,0,1,1,4,6.5,2.5,2.5,0,0,1,6.5,4Zm11,7A4.5,4.5,0,1,0,13,6.5,4.51,4.51,0,0,0,17.5,11Zm0-7A2.5,2.5,0,1,1,15,6.5,2.5,2.5,0,0,1,17.5,4Zm4.21,11.71L19.41,18l2.3,2.29-1.42,1.42L18,19.41l-2.29,2.3-1.42-1.42L16.59,18l-2.3-2.29,1.42-1.42L18,16.59l2.29-2.3Zm-12-1.42L13.41,18l-3.7,3.71L8.29,20.29,9.59,19H8a5,5,0,0,1-5-5V12H5v2a3,3,0,0,0,3,3H9.59l-1.3-1.29Z",
    fill: "#242f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24PxStrategicPlanning01);
export default __webpack_public_path__ + "static/media/24px-strategic-planning-01.b32cf8141a07e666f1fee522ce939a1c.svg";
export { ForwardRef as ReactComponent };